module.exports = __webpack_public_path__ + "img/logo-pusuqui.50761f01.png";